import { customAlphabet } from "nanoid";

export const CONTENT_TYPE: { [key: string]: string } = {
  pdf: "application/pdf",
  epub: "application/epub+zip",
  html: "text/html",
  //   'xps': 'application/vnd.ms-xpsdocument',
  //   'cbz': 'application/vnd.comicbook+zip',
  //   'fb2': 'application/x-fictionbook+xml',
};

export const getExtension = (contentType: string) => {
  return Object.keys(CONTENT_TYPE).find(
    (key) => CONTENT_TYPE[key] === contentType,
  );
};

export enum IDPrefix {
  BOOK = "book",
}

const nanoid = customAlphabet(
  "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz",
  10,
);

export const generateId = (prefix: IDPrefix) => `${prefix}_${nanoid()}`;

export const getType = (id: string) => {
  const [type] = id.split("_");
  return type;
};
